/**
 * Microsoft Authentication Library (MSAL) configuration
 * Aligned with opticusdocumentationapp-ui/src/config/authConfig.ts
 */
import { LogLevel, PublicClientApplication } from '@azure/msal-browser';

const clientId = 'ca4b937a-053d-42ab-8940-b86525469dd4';
const tenantId = '05d75c05-fa1a-42e7-9cf1-eb416c396f2d';
// Dynamic origin so the hidden iframe for silent token refresh works in every
// environment (localhost, staging, production) without Azure AD redirect URI
// mismatches that cause timed_out errors.
const redirectUri = window.location.origin;
export const silentRedirectUri = `${window.location.origin}/auth-silent.html`;

// ── MSAL instance configuration ─────────────────────────────────────────────
export const msalConfig = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
    postLogoutRedirectUri: redirectUri,
  },
  cache: {
    cacheLocation: 'localStorage',      // matches reference repo
    storeAuthStateInCookie: true,        // matches reference repo
  },
  system: {
    // Production ingress/proxy can slow hidden iframe auth callbacks.
    // Raise timeouts to avoid false timed_out failures during silent renew.
    iframeHashTimeout: 30000,
    loadFrameTimeout: 30000,
    windowHashTimeout: 30000,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:   console.error(message); return;
          case LogLevel.Warning: console.warn(message);  return;
          default:               return;
        }
      },
      logLevel: LogLevel.Verbose,
    },
  },
};

// Single shared instance — import this everywhere instead of creating new ones
export const msalInstance = new PublicClientApplication(msalConfig);

// Scopes for login — matches reference repo exactly
export const loginRequest = {
  scopes: ['User.Read'],
};

// Clear only known temporary MSAL keys that can be left stale in normal
// browser profiles and cause persistent interaction_in_progress/timed_out.
export function clearStaleMsalTemporaryCache() {
  const fragments = [
    'interaction.status',
    'request.state',
    'nonce.idtoken',
    'authority',
    'request.origin',
  ];

  const stores = [window.sessionStorage, window.localStorage];
  let removed = 0;

  stores.forEach((store) => {
    const keysToRemove = [];
    for (let i = 0; i < store.length; i += 1) {
      const key = store.key(i);
      if (!key || !key.startsWith('msal.')) continue;
      if (fragments.some((fragment) => key.includes(fragment))) {
        keysToRemove.push(key);
      }
    }

    keysToRemove.forEach((key) => {
      store.removeItem(key);
      removed += 1;
    });
  });

  return removed;
}
